import { Link } from 'react-router-dom';
import { usePageMeta, Reveal, APP_STORE_URL } from '../lib/site';
import { CardHeader } from '../components/Bits';

export default function Download() {
  usePageMeta(
    'Get the app | MyGolfLinks',
    'The MyGolfLinks iPhone app is live on the App Store, free. GPS distances, scoring, stats, deals from real courses, and a handicap that keeps itself current.'
  );

  return (
    <main>
      <section style={{ padding: 'clamp(140px, 16vw, 180px) 0 clamp(48px, 6vw, 72px)' }}>
        <div className="wrap">
          <Reveal>
            <p className="mono" style={{ fontSize: 12.5, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--fairway)', fontWeight: 500, marginBottom: 20 }}>
              Get the app
            </p>
            <h1 className="display" style={{ maxWidth: 720 }}>Free on iPhone. Go play.</h1>
            <p className="lede" style={{ margin: '24px 0 32px' }}>
              GPS distances, scoring and stats, deals straight from real courses, and a handicap
              that keeps itself current. The app is live on the App Store, free.
            </p>
            <div style={{ display: 'flex', gap: 14, alignItems: 'center', flexWrap: 'wrap' }}>
              <a href={APP_STORE_URL} className="btn btn-gold">Download on the App Store</a>
              <span style={{ fontSize: '0.9rem', color: 'var(--mut)' }}>iPhone today. Android is coming.</span>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="band-card">
        <div className="wrap" style={{ padding: 'clamp(60px, 8vw, 96px) clamp(20px, 4.5vw, 44px)' }}>
          <Reveal>
            <CardHeader no="01" label="Three steps" />
            <h2 className="h2" style={{ maxWidth: 620 }}>From zero to first tee</h2>
          </Reveal>
          <Reveal className="ledger" style={{ marginTop: 38 }}>
            <div className="led">
              <span className="led-no">1</span>
              <span className="led-title">Create your account</span>
              <span className="led-body">
                Pick a username, set your home course, and you're in. No card required.
              </span>
            </div>
            <div className="led">
              <span className="led-no">2</span>
              <span className="led-title">Find your people</span>
              <span className="led-body">
                Add friends, join a group, and follow your favorite courses.
              </span>
            </div>
            <div className="led">
              <span className="led-no">3</span>
              <span className="led-title">Play a round</span>
              <span className="led-body">
                Fire up live GPS, score as you walk, and share your card when you're done.
              </span>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="band-pine on-pine">
        <div className="wrap" style={{ padding: 'clamp(64px, 9vw, 100px) clamp(20px, 4.5vw, 44px)' }}>
          <Reveal style={{ maxWidth: 620 }}>
            <h2 className="h2">It's free. Go play.</h2>
            <div style={{ marginTop: 28, display: 'flex', gap: 14, flexWrap: 'wrap' }}>
              <a href={APP_STORE_URL} className="btn btn-gold">Download on the App Store</a>
            </div>
            <p style={{ marginTop: 22, fontSize: '0.92rem', color: 'var(--cream-mut)' }}>
              Want the full tour first? <Link to="/golfers" className="tlink">See what's in the app.</Link>
            </p>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
